var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-slider.ts
import "@adornis/base/utilTypes.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
var XSlider = class extends FormField {
  constructor() {
    super(...arguments);
    this.value = new RXController(this, 0);
  }
  render() {
    return html`
      ${this.error ? html` <x-text tone="error"> ${this.error} </x-text> ` : nothing}
      <input
        ${acss({
      width: "100%",
      "-webkit-appearance": "none",
      height: "4px",
      borderRadius: "2px",
      background: this.colors.primary,
      outline: "none",
      "&::-webkit-slider-runnable-track": {
        "-webkit-appearance": "none",
        background: `linear-gradient(to bottom, transparent 0%, transparent 33%, ${this.colors.neutral.shade(
          200
        )} 33%, ${this.colors.neutral.shade(200)} 66%, transparent 66%, transparent 100%)`
      }
    })}
        type="range"
        ${injectAttributesOf(this)}
        .value=${this.value.value}
        @input=${(e) => {
      if (+e.currentTarget.value !== this.value.value)
        this.value.next(+e.currentTarget.value);
    }}
        @blur=${() => this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }))}
      />
    `;
  }
};
XSlider = __decorateClass([
  customElement("x-slider")
], XSlider);
export {
  XSlider
};
